import React from "react";
import BackButton from "components/BackButton";

const Credits: React.FC = () => {
  return (
    <div className="bg-[#BCB7A8] font-['IBM_Plex_Mono',monospace] text-black m-0 p-0 flex flex-col justify-start items-center h-[100vh]">
      <div className="container w-auto h-full p-3 overflow-auto md:mt-5 md:max-w-[900px]">
        <div className="header text-[2rem] font-bold leading-[1.6] mb-8">
          Credits
        </div>

        <p className="mb-6 text-xl leading-relaxed">
          Wetland Game is a collaborative effort between the curatorial team of
          Martin Guinard and Salma Mochtari (LUMA, France), scientist Raphaël
          Mathevet (CNRS EPHE CEFE, France), artists Nomeda &amp; Gediminas
          Urbonas (MIT, USA), programmers Terry Kang and Thomas Lee Harriett
          (USA), with design in collaboration with NODE Berlin.
        </p>

        <p className="mb-6 text-xl leading-relaxed">
          Wetland Game is part of the Shadow Biosphere Observatory – a project
          in progress supported by LUMA Arles, La Saison de la Lituanie en
          France 2024, the Creative Interdisciplinary New European Bauhaus - NEB
          Research Centre, and MIT Center for Art, Science and Technology. The
          project is part of the Season of Lithuania in France 2024. The Season
          is organized by the Lithuanian culture Institute and the French
          Institute in Paris.
        </p>

        <p className="mb-6 text-xl leading-relaxed">
          *ButorStar has been developed in the context of a LIFE-Nature European
          Programme (2001-2005) aiming to improve reedbed management for the
          conservation of a vulnerable heron, the Eurasian Bittern, by the
          interdisciplinary team of Raphaël Mathevet, CNRS CEFE, Tour du Valat;
          Christophe Le Page, CIRAD, Michel Etienne, INRAE, Gaëtan Lefebvre,
          Tour du Valat; Sophie Proréol, Amis des Marais du Vigueirat; Brigitte
          Poulin, Tour du Valat; Guillaume Gigot, CIRAD, CNRS CEFE; André
          Mauchamp, Tour du Valat, F. Mesléard, Tour du Valat.
        </p>
      </div>

      <div className="footer fixed bottom-8 left-8 w-[100vw]">
        <BackButton />
      </div>
    </div>
  );
};

export default Credits;
